import React, { useEffect, useState } from "react";

export default function WelcomeModal() {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const escHandler = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", escHandler);
    return () => document.removeEventListener("keydown", escHandler);
  }, []);

  if (!open) return null;

  return (
    <div className="modal">
      <div className="modal-overlay" onClick={() => setOpen(false)}></div>
      <div className="modal-content">
        <div className="welcome-content">
          <h2>NAMASTE🙏</h2>
          <h3>WELCOME TO NARMADA SOLAR SOLUTIONS</h3>
          <button
            onClick={() => setOpen(false)}
            className="btn btn--primary btn--lg"
          >
            Enter Website
          </button>
        </div>
      </div>
    </div>
  );
}
